import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ProductBrand, ProductBrandCreate, ProductBrandFilter } from '../data/productBrand';

export function createProductBrandService(client: AxiosInstance) {
  return createCrudService<ProductBrand, ProductBrandCreate, ProductBrandFilter>(
    client,
    '/master-data/ProductBrand',
    'id',
  );
}

export type ProductBrandService = CrudService<ProductBrand, ProductBrandCreate, ProductBrandFilter>;
